import { extendTheme } from "@chakra-ui/react";
import { STANDE } from "./StandeClassroom/standeTokens";

const theme = extendTheme({
  styles: {
    global: {
      body: {
        fontFamily: "Mona Sans, sans-serif",
      },
    },
  },
  fonts: {
    body: "Mona Sans, sans-serif",
    heading: "Mona Sans, sans-serif",
  },
  components: {
    /**
     * Every tooltip in the app, in one place (Figma 295:61, 295:62, 295:66).
     *
     * A stande-black bubble with stande-grey words and a 4px corner. Set on
     * the theme rather than passed at each call site: there are dozens of
     * them across the board, the paper and the classroom, and they have to
     * stay the same as the design moves.
     */
    Tooltip: {
      baseStyle: {
        bg: STANDE.black,
        color: STANDE.grey,
        borderRadius: "4px",
        px: "10px",
        py: "3px",
        fontSize: "11px",
        fontWeight: 400,
        lineHeight: "16px",
        boxShadow: "0 4px 12px -6px rgba(0,0,0,0.45)",
        // The arrow is drawn separately and does not inherit the bubble.
        "--popper-arrow-bg": STANDE.black,
      },
    },
    Button: {
      baseStyle: {
        borderRadius: "8px",
        _hover: {
          bg: "none",
          boxShadow: "none",
        },
        _focus: {
          boxShadow: "none",
        },
        _active: {
          bg: "none",
          boxShadow: "none",
        },
      },
      sizes: {
        md: {
          px: "16px",
          py: "8px",
        },
      },
      variants: {
        ghost: {
          _hover: {
            bg: "none",
          },
        },
        menuButton: {
          bg: "#ffffff",
          border: "none",
          color: "#021A04",
          _hover: {
            bg: "#F5F5F5",
            color: "#021A04",
            boxShadow: "none",
          },
          _focus: {
            bg: "none",
            boxShadow: "none",
          },
          _active: {
            bg: "none",
            boxShadow: "none",
          },
        },
      },
    },

    // Menu styling
    Menu: {
      parts: ["button", "list", "item"],
      baseStyle: {
        button: {
          bg: "#ffffff",
          border: "none",
          color: "#021A04",
          _hover: {
            bg: "#F5F5F5",
            color: "#021A04",
            boxShadow: "none",
          },
          _focus: {
            boxShadow: "none",
          },
          _active: {
            bg: "none",
            boxShadow: "none",
          },
        },
        list: {
          borderRadius: "8px",
          boxShadow: "0px 0px 5.9px rgba(0, 0, 0, 0.14)",
          _focus: {
            boxShadow: "none",
          },
        },
        item: {
          bg: "transparent",
          _hover: {
            bg: "transparent",
            color: "#021A04",
          },
          _focus: {
            bg: "transparent",
            boxShadow: "none",
          },
          _active: {
            bg: "transparent",
            boxShadow: "none",
          },
          _selected: {
            bg: "transparent",
            boxShadow: "none",
          },
        },
      },
    },

    // MenuItem base style override
    MenuItem: {
      baseStyle: () => ({
        bg: "transparent",
        _hover: {
          bg: "transparent",
        },
        _focus: {
          bg: "transparent",
          boxShadow: "none",
        },
        _active: {
          bg: "transparent",
        },
      }),
    },

    // Checkbox styling
    Checkbox: {
      baseStyle: {
        control: {
          width: "18px",
          height: "18px",
          borderRadius: "4px",
          border: "1px solid #E7EAE8",
          boxShadow: "1px 1px 19.3px 0px rgba(0, 0, 0, 0.05)",
          fontSize: "14px",
          fontWeight: "400",
          _checked: {
            bg: "#4BFF5C",
            borderColor: "#4BFF5C",
            color: "#ffffff",
            _hover: {
              bg: "#4BFF5C",
              borderColor: "#4BFF5C",
            },
            _before: {
              content: '""',
              display: "block",
              width: "100%",
              height: "100%",
            },
          },
          _hover: {
            bg: "transparent",
            borderColor: "#4BFF5C",
          },
        },
        icon: {
          color: "#08250B",
        },
      },
    },

    // IconButton override to remove all default styles
    IconButton: {
      baseStyle: {
        bg: "transparent",
        border: "none",
        _hover: { bg: "transparent" },
        _active: { bg: "transparent" },
        _focus: { boxShadow: "none" },
      },
    },
  },
});

export default theme;
